const achievementEnumerators = {
  type: [
    'frequency_plays',
    'frequency_minutes',
    'longest_streak',
    'meditation_sessions',
  ],
};

export default achievementEnumerators; 